module.exports = __webpack_public_path__ + "static/media/open_up.fda01e8b.png";